var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDocker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2496ED"
    },
    d: "M506.983,211.064c-1.362-1.075-14.333-10.893-41.71-10.893c-7.238,0-14.405,0.645-21.572,1.863   c-5.303-36.263-35.26-53.965-36.621-54.753l-7.31-4.228l-4.802,6.952c-6.02,9.388-10.463,19.708-13.043,30.53   c-4.873,20.711-1.935,40.133,8.6,56.759c-12.685,7.095-33.11,8.815-37.195,8.958H16c-8.815,0-15.981,7.167-15.981,15.91   c-0.358,29.526,4.587,58.91,14.763,86.644c11.61,30.458,28.881,52.889,51.385,66.649c25.226,15.408,66.148,24.223,112.587,24.223   c20.998,0.072,41.925-1.863,62.493-5.662c28.666-5.232,56.258-15.265,81.556-29.67c20.855-12.111,39.703-27.52,55.685-45.579   c26.731-30.243,42.641-63.926,54.466-93.882c1.577,0,3.153,0,4.73,0c29.24,0,47.228-11.682,57.189-21.5   c6.593-6.235,11.753-13.903,15.05-22.36l2.078-6.163L506.983,211.064z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2496ED"
    },
    d: "M47.246,236.363h45.221c2.15,0,3.942-1.792,3.942-3.942l0,0v-40.276c0-2.15-1.72-3.942-3.942-3.942   l0,0H47.246c-2.15,0-3.942,1.792-3.942,3.942l0,0v40.276C43.304,234.571,45.096,236.363,47.246,236.363L47.246,236.363"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2496ED"
    },
    d: "M109.524,236.363h45.221c2.15,0,3.942-1.792,3.942-3.942l0,0v-40.276c0-2.15-1.72-3.942-3.942-3.942   l0,0h-45.221c-2.222,0-3.942,1.792-3.942,3.942v40.276C105.582,234.571,107.374,236.363,109.524,236.363"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2496ED"
    },
    d: "M172.805,236.363h45.221c2.15,0,3.942-1.792,3.942-3.942l0,0v-40.276c0-2.15-1.72-3.942-3.942-3.942   l0,0h-45.221c-2.15,0-3.942,1.792-3.942,3.942l0,0v40.276C168.863,234.571,170.583,236.363,172.805,236.363L172.805,236.363"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2496ED"
    },
    d: "M235.298,236.363h45.221c2.15,0,3.942-1.792,3.942-3.942v-40.276c0-2.222-1.792-3.942-3.942-3.942   l0,0h-45.221c-2.15,0-3.942,1.792-3.942,3.942l0,0v40.276C231.356,234.571,233.076,236.363,235.298,236.363L235.298,236.363"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2496ED"
    },
    d: "M109.524,178.456h45.221c2.15,0,3.942-1.792,3.942-3.942v-40.276c0-2.15-1.792-3.942-3.942-3.942   l0,0h-45.221c-2.15,0-3.942,1.792-3.942,3.942v40.276C105.582,176.665,107.374,178.456,109.524,178.456"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2496ED"
    },
    d: "M172.805,178.456h45.221c2.15,0,3.942-1.792,3.942-3.942v-40.276c0-2.15-1.792-3.942-3.942-3.942   l0,0h-45.221c-2.15,0-3.942,1.792-3.942,3.942l0,0v40.276C168.863,176.665,170.583,178.456,172.805,178.456"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2496ED"
    },
    d: "M235.298,178.456h45.221c2.222,0,3.942-1.792,3.942-3.942v-40.276c0-2.15-1.792-3.942-3.942-3.942   h-45.221c-2.15,0-3.942,1.792-3.942,3.942l0,0v40.276C231.356,176.665,233.076,178.456,235.298,178.456"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2496ED"
    },
    d: "M235.298,120.479h45.221c2.15,0,3.942-1.792,3.942-3.942V76.261c0-2.15-1.792-3.942-3.942-3.942   h-45.221c-2.15,0-3.942,1.792-3.942,3.942l0,0v40.276C231.356,118.759,233.076,120.479,235.298,120.479"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2496ED"
    },
    d: "M298.292,236.363h45.221c2.15,0,3.942-1.792,3.942-3.942v-40.276c0-2.222-1.792-3.942-3.942-3.942   l0,0h-45.221c-2.15,0-3.942,1.792-3.942,3.942l0,0v40.276C294.35,234.571,296.142,236.363,298.292,236.363"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocker);
export default __webpack_public_path__ + "static/media/icon_docker.157d247a61ac3019baa5cac764228916.svg";
export { ForwardRef as ReactComponent };